import React, { useEffect, useState } from 'react'
import { Image } from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import { api_gateway } from '../../../conexoes/api'
import '../../../css/painelFaturas/fatCicloVida/tabela.css'
import {
  desabilitarAcoes,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  mudarOrdenador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem,
  revelarDoppelgangerCliente,
  visualizarDadosRefresh
} from '../../../redux/actions/index'
import { setaDropdown } from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'
import Table from '../../Table/index.jsx'

import NovaCiclo from './novoCiclo/novoCiclo'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
const valorLimite = 50

const TableprimaryKey = 'CD_CICLO_VIDA'

function TabelaClientesVirtueyes() {
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  //   const [mensagemErro, setMensagemErro] = useState('')
  //   const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  //   const [
  //     revelarMensagemAtencaoCicloPadrao,
  //     setRevelarMensagemAtencaoCicloPadrao
  //   ] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  //   const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)

  let itensVar = []

  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let revelarNovoCiclo = useSelector(
    (state) => state.faturasState.revelarNovoCicloVida
  )

  let ordenador = useSelector((state) => state.manejadorState.ordenador)

  //   let revelarExcluirCicloVida = useSelector(
  //     (state) => state.faturasState.revelarExcluirCicloVida
  //   )
  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let visualizarDadosRefreshVar = useSelector(
    (state) => state.virtueyesState.visualizarDadosRefresh
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  const [spinAtivo, setSpinAtivo] = useState(true)
  const despacho = useDispatch()
  const cd_pav_usuario = decryptJWT('codigo')
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(729) // 'fatCicloVidaTabela'
      setColetaUsabilidade(false)
    }
  }, [])

  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
  }, [])

  useEffect(() => {
    setSpinAtivo(true)
    despacho(mudarManejador('faturasCicloVida'))
    despacho(desabilitarAcoes(true))
    async function carregarTabela() {
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }
      if (ordenador) {
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            '/m1/consultar/fat_ciclo_vida?paginaAtual=' +
              contador +
              '&ordenador=' +
              ordenador +
              '&carregarLimit=' +
              valorLimite +
              '&buscar=' +
              conteudoBusca +
              '&cd_pav_usuario=' +
              cd_pav_usuario
          )
          inserirData(data.dados)
        }
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paginaAtual: contador,
          carregarLimit: valorLimite,
          filtros: filtros,
          ordenador: ordenador,
          cd_pav_usuario: cd_pav_usuario
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post(
            '/m1/filtrar/fat_ciclo_vida',
            dados
          )

          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            '/m1/consultar/fat_ciclo_vida?paginaAtual=' +
              contador +
              '&ordenador=' +
              ordenador +
              '&carregarLimit=' +
              valorLimite +
              '&cd_pav_usuario=' +
              cd_pav_usuario
          )
          inserirData(data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, renderizar, filtros, ordenador])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual && filtros.vazio) {
      apiData = await api_gateway.get(
        '/m1/consultar/fat_ciclo_vida?contar=true&buscar=' +
          conteudoBusca +
          '&ordenador=' +
          ordenador +
          '&cd_pav_usuario=' +
          cd_pav_usuario
      )
    } else {
      const dados = {
        paginaAtual: contador,
        carregarLimit: valorLimite,
        buscar: conteudoBusca,
        filtros: filtros,
        contar: true,
        ordenador,
        cd_pav_usuario: cd_pav_usuario
      }

      apiData = await api_gateway.post('/m1/filtrar/fat_ciclo_vida', dados)
    }
    totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
    totalItens = apiData.data.dados[0].CONTADOR
    for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
      arrayItens.push(i)
    }
    itensVar = arrayItens
  }

  const colunas = [
    {
      dataField: 'CD_CICLO_VIDA',
      text: 'ID',
      headerClasses: 'nao-selecionavel',
      hidden: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'DS_STATUS',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('ds_status', 'ds_status')}
        >
          Status
          <Image
            id="ds_statusds_status"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' || cell !== null || cell !== undefined ? cell : -1}
          </p>
        )
      }
    },
    {
      dataField: 'DS_STATUS_OPERADORA',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() =>
            handlerOrdenador('ds_status_operadora', 'ds_status_operadora')
          }
        >
          Status operadora
          <Image
            id="ds_status_operadorads_status_operadora"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' || cell !== null || cell !== undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'FL_INICIAL',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() =>
            handlerOrdenador('fl_status_inicial', 'fl_status_inicial')
          }
        >
          Status inicial
          <Image
            id="fl_status_inicialfl_status_inicial"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' || cell !== null || cell !== undefined
              ? cell == 1
                ? 'Sim'
                : 'Não'
              : 'Não'}
          </p>
        )
      }
    },
    {
      dataField: 'FL_ATIVO',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('fl_status_ativo', 'fl_status_ativo')}
        >
          Staus ativo
          <Image
            id="fl_status_ativofl_status_ativo"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' || cell !== null || cell !== undefined
              ? cell == 1
                ? 'Sim'
                : 'Não'
              : 'Não'}
          </p>
        )
      }
    },
    {
      dataField: 'FL_FATURA',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('fl_fatura', 'fl_fatura')}
        >
          Fatura
          <Image
            id="fl_faturafl_fatura"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' || cell !== null || cell !== undefined
              ? cell == 1
                ? 'Sim'
                : 'Não'
              : 'Não'}
          </p>
        )
      }
    },
    {
      dataField: 'FL_AUTOMACAO',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('fl_automacao', 'fl_automacao')}
        >
          Automação
          <Image
            id="fl_automacaofl_automacao"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' || cell !== null || cell !== undefined
              ? cell == 1
                ? 'Sim'
                : 'Não'
              : 'Não'}
          </p>
        )
      }
    },
    {
      dataField: 'FL_CANCELAMENTO',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('fl_cancelamento', 'fl_cancelamento')}
        >
          Cancelamento
          <Image
            id="fl_cancelamentofl_cancelamento"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' || cell !== null || cell !== undefined
              ? cell == 1
                ? 'Sim'
                : 'Não'
              : 'Não'}
          </p>
        )
      }
    },
    {
      dataField: 'n0_simcards',
      headerClasses: 'nao-selecionavel',
      text: (
        <button
          className="btn-header-nome fonte-cor-1"
          onClick={() => handlerOrdenador('n0_simcards', 'n0_simcards')}
        >
          Número de SIM cards
          <Image
            id="n0_simcardsn0_simcards"
            className="d-none"
            src={setaDropdown()}
          />
        </button>
      ),
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    }
  ]

  function handlerDesativarImagens(imagem, terminacao) {
    const elementosAtivosDESC = document.querySelectorAll(
      '.icone-ordenacao-DESC'
    )
    const elementosAtivosASC = document.querySelectorAll('.icone-ordenacao-ASC')
    elementosAtivosDESC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosASC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )

    imagem.classList.remove('d-none')
    imagem.classList.add('icone-ordenacao-' + terminacao)
  }

  function handleRemoverImagens(imagem) {
    const elementosAtivosDESC = document.querySelectorAll(
      '.icone-ordenacao-DESC'
    )
    const elementosAtivosASC = document.querySelectorAll('.icone-ordenacao-ASC')
    elementosAtivosDESC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosASC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    imagem.classList.remove('icone-ordenacao-ASC')
    imagem.classList.remove('icone-ordenacao-DESC')
  }

  async function handlerOrdenador(nomeOrdenador, nomeDiferenciado) {
    let isItDescrescente = false
    const imagem = document.getElementById(nomeOrdenador + nomeDiferenciado)

    if (
      nomeOrdenador === ordenador.split(' ASC')[0] ||
      nomeOrdenador === ordenador.split(' DESC')[0]
    ) {
      await ordenador.split(' ').map((item_ordenador) => {
        if (item_ordenador === 'ASC') {
          ordenador = nomeOrdenador + ' DESC'
          isItDescrescente = true
          handlerDesativarImagens(imagem, 'ASC')
        }
        if (item_ordenador === 'DESC') {
          ordenador = ''
          isItDescrescente = false
          handleRemoverImagens(imagem)
        }
      })
    } else if (!isItDescrescente) {
      ordenador = nomeOrdenador + ' ASC'
      handlerDesativarImagens(imagem, 'DESC')
    }
    despacho(mudarOrdenador(JSON.parse(JSON.stringify(ordenador))))
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    despacho(desabilitarAcoes(true))
    setPaginaAtual(1)
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      despacho(revelarDoppelgangerCliente(false))
      despacho(visualizarDadosRefresh(!visualizarDadosRefreshVar))
    }
  }

  //   function handleMensagemErro() {
  //     if (revelarMensagemErro === false) {
  //       setRevelarMensagemErro(true)
  //     } else {
  //       setRevelarMensagemErro(false)
  //     }
  //   }

  //   async function handleCancelar() {
  //     contador = 0
  //     controladorPagina = 1
  //     totalPaginas = 0
  //     totalItens = 0
  //     itensVar = []
  //     setRevelarMensagemAtencaoCicloPadrao(false)
  //     despacho(revelarExcluirCicloVidaFunc(false))
  //   }

  //   function handleMensagemAtencao(confirmacao) {
  //     if (flPadrao === 0) {
  //       if (revelarMensagemAtencao === false) {
  //         setRevelarMensagemAtencao(true)
  //       } else {
  //         setRevelarMensagemAtencao(false)
  //         despacho(revelarExcluirCicloVidaFunc(false))
  //         setRevelarMensagemAtencaoCicloPadrao(false)
  //         if (confirmacao === true) {
  //           ColetaClickstream(1303) // fatCicloVidaTabelaDropAcoesExcluirCicloVidaDeletar
  //           handleDeletar()
  //         } else {
  //           ColetaClickstream(743) // fatCicloVidaTabelaDropAcoesExcluirCicloVidaCancelar
  //         }
  //       }
  //     }

  //     if (flPadrao === 1) {
  //       if (revelarMensagemAtencaoCicloPadrao === false) {
  //         setRevelarMensagemAtencaoCicloPadrao(true)
  //       } else {
  //         setRevelarMensagemAtencaoCicloPadrao(false)
  //         despacho(revelarExcluirCicloVidaFunc(false))
  //         if (confirmacao === true) {
  //           handleCancelar()
  //         }
  //       }
  //     }
  //   }

  //   async function handleDeletar() {
  //     setSpinAtivo(true)

  //     await api_gateway
  //       .get('/m1/deletar/fat_ciclo_vida?cd_fat_ciclo_vida=' + cdCicloVida)
  //       .then(function (response) {
  //         if (response.data.status === 600) {
  //           setMensagemErro(response.data.info)
  //           despacho(revelarExcluirCicloVidaFunc(false))
  //           handleMensagemErro(false)
  //           setSpinAtivo(false)
  //         } else {
  //           setRenderizar(!renderizar)
  //           despacho(revelarExcluirCicloVidaFunc(false))
  //           handleMensagemSucesso(false)
  //           setSpinAtivo(false)
  //         }
  //       })
  //       .catch(function () {
  //         setMensagemErro('Erro ao excluir ciclo de vida!')
  //         despacho(revelarExcluirCicloVidaFunc(false))
  //         handleMensagemErro(false)
  //         setSpinAtivo(false)
  //       })
  //   }

  //   useEffect(() => {
  //     if (revelarExcluirCicloVida) {
  //       setRevelarMensagemAtencao(true)
  //     }
  //   }, [revelarExcluirCicloVida])

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  return (
    <div className="container-tela">
      <Table
        keyField={TableprimaryKey}
        revelarContador
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1={
                'O ciclo de vida ' + status + ' foi deletado.'
              }
              mensagemBotao="OK"
            />
          </div>
        </div>
      )}
      {/* {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo3={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )} */}
      {revelarNovoCiclo === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <NovaCiclo
              tituloJanela="Cadastrar"
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}

      {/* {revelarEditarCiclo === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <NovaCiclo
              tituloJanela="Editar"
              cdCicloVida={cdCicloVida}
              status={status}
              statusOperadora={statusOperadora}
              statusInicial={statusInicial}
              statusAtivo={statusAtivo}
              fatura={fatura}
              automacao={automacao}
              cancelamento={cancelamento}
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}

      {revelarMensagemAtencao === true && (
        <MensagemConfirmarExclusao
          handleMensagemAtencao={handleMensagemAtencao}
          mensagemTitulo={'Deletar ' + status}
        />
      )}

      {revelarMensagemAtencaoCicloPadrao === true && (
        <MensagemAtencao
          handleMensagemAtencao={handleMensagemAtencao}
          mensagemTitulo="Atenção!"
          mensagemParagrafo1="Não é possível deletar um ciclo de vida padrão!"
          mensagemBotao="Voltar"
        />
      )} */}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros,
    visualizarDadosRefreshVar: state.virtueyesState.visualizarDadosRefresh
  }
}

export default connect(mapStateToProps)(React.memo(TabelaClientesVirtueyes))
